export const setRollouts = (state, { payload: { rollouts } }) => ({ ...state, ...rollouts });
